import React from 'react';
import { motion } from 'framer-motion';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  .tp-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .tp-page { font-family: 'Inter', sans-serif; color: #0f172a; background: #ffffff; width: 100%; }

  /* ─── Hero ─────────────────────────────────────────────────── */
  .tp-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .tp-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 520px; height: 520px; border-radius: 50%; background: radial-gradient(circle, rgba(16,185,129,0.15), rgba(5,150,105,0.06)); filter: blur(80px); pointer-events: none; }
  .tp-hero-blob2 { position: absolute; bottom: -12%; left: -8%; width: 560px; height: 560px; border-radius: 50%; background: radial-gradient(circle, rgba(14,165,233,0.1), rgba(56,189,248,0.05)); filter: blur(90px); pointer-events: none; }
  .tp-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .tp-hero-inner { grid-template-columns: 1fr; } .tp-hero-visual { display: none; } }
  .tp-back-btn { display: inline-flex; align-items: center; gap: 6px; padding: 7px 16px; border-radius: 999px; border: 1px solid #e2e8f0; background: #fff; color: #475569; font-size: 12px; font-weight: 600; cursor: pointer; transition: all 0.18s ease; margin-bottom: 24px; }
  .tp-back-btn:hover { background: #f0fdf4; border-color: #6ee7b7; color: #059669; }
  .tp-hero-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #f0fdf4; border: 1px solid #d1fae5; font-size: 13px; font-weight: 500; color: #065f46; margin-bottom: 28px; }
  .tp-badge-dot { width: 7px; height: 7px; border-radius: 50%; background: #10b981; display: inline-block; animation: tp-pulse 2s infinite; }
  @keyframes tp-pulse { 0%,100%{opacity:1;box-shadow:0 0 0 0 rgba(16,185,129,0.4);}50%{opacity:.85;box-shadow:0 0 0 6px rgba(16,185,129,0);} }
  .tp-hero h1 { font-size: clamp(1.8rem, 3.75vw, 3rem); font-weight: 900; line-height: 1.1; letter-spacing: -0.03em; color: #0f172a; margin-bottom: 24px; }
  .tp-gradient-text { background: linear-gradient(135deg, #059669, #0ea5e9); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .tp-hero p { font-size: 1.15rem; color: #475569; line-height: 1.75; margin-bottom: 40px; font-weight: 300; max-width: 520px; }
  .tp-btn-group { display: flex; gap: 14px; flex-wrap: wrap; }
  .tp-btn-primary { padding: 14px 28px; background: #0f172a; color: #fff; border: none; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .tp-btn-primary:hover { background: #059669; box-shadow: 0 8px 24px rgba(5,150,105,0.35); transform: translateY(-1px); }
  .tp-btn-secondary { padding: 14px 28px; background: #fff; color: #334155; border: 1.5px solid #e2e8f0; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .tp-btn-secondary:hover { border-color: #6ee7b7; background: #f0fdf4; color: #065f46; }

  /* Hero Visual */
  .tp-hero-visual { background: #fff; border-radius: 28px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(5,150,105,0.08); }
  .tp-vis-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; padding-bottom: 18px; border-bottom: 1px solid #f1f5f9; }
  .tp-vis-title p:first-child { font-size: 11px; color: #94a3b8; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 3px; }
  .tp-vis-title p:last-child { font-size: 17px; font-weight: 800; color: #0f172a; }
  .tp-vis-icon { width: 46px; height: 46px; background: linear-gradient(135deg, #059669, #10b981); border-radius: 13px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .tp-doc-item { display: flex; align-items: center; gap: 12px; padding: 12px 14px; border-radius: 11px; margin-bottom: 8px; border: 1px solid #f1f5f9; background: #f8fafc; transition: all 0.2s; }
  .tp-doc-item.done { background: #f0fdf4; border-color: #d1fae5; }
  .tp-doc-check { width: 22px; height: 22px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; flex-shrink: 0; }
  .tp-doc-check.done { background: #059669; color: #fff; }
  .tp-doc-check.pending { background: #e2e8f0; color: #94a3b8; border: 2px dashed #cbd5e1; }
  .tp-doc-label { font-size: 13px; font-weight: 600; color: #374151; flex: 1; }
  .tp-doc-label.done { color: #065f46; }
  .tp-doc-status { font-size: 11px; font-weight: 700; }
  .tp-doc-status.done { color: #059669; }
  .tp-doc-status.pending { color: #94a3b8; }
  .tp-vis-progress { margin-top: 18px; padding: 16px; background: #0f172a; border-radius: 12px; }
  .tp-vis-progress-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
  .tp-vis-progress-top span:first-child { font-size: 12px; color: #94a3b8; font-weight: 500; }
  .tp-vis-progress-top span:last-child { font-size: 13px; color: #34d399; font-weight: 700; }
  .tp-progress-bar { height: 6px; background: rgba(255,255,255,0.1); border-radius: 999px; overflow: hidden; }
  .tp-progress-fill { height: 100%; width: 80%; background: linear-gradient(90deg, #10b981, #34d399); border-radius: 999px; }

  /* ─── Stats ─────────────────────────────────────────────────── */
  .tp-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .tp-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .tp-stats-grid { grid-template-columns: repeat(2,1fr); } }
  .tp-stat { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .tp-stat:last-child { border-right: none; }
  @media (max-width: 768px) { .tp-stat:nth-child(2n){ border-right:none; } .tp-stat{ border-bottom:1px solid #f1f5f9; } }
  .tp-stat-num { font-size: 2.2rem; font-weight: 900; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; color: #059669; }
  .tp-stat-num.dark { color: #0f172a; }
  .tp-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ─── Section Base ───────────────────────────────────────────── */
  .tp-section { padding: 96px 24px; }
  .tp-container { max-width: 1200px; margin: 0 auto; }
  .tp-section-header { text-align: center; max-width: 700px; margin: 0 auto 64px; }
  .tp-section-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .tp-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.75; }
  .tp-label { display: inline-block; font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #059669; margin-bottom: 12px; }

  /* ─── What's Included ───────────────────────────────────────── */
  .tp-included { background: #f8fafc; }
  .tp-included-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 24px; }
  @media (max-width: 900px) { .tp-included-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 600px) { .tp-included-grid { grid-template-columns: 1fr; } }
  .tp-inc-card { background: #fff; border-radius: 20px; border: 1px solid #e2e8f0; padding: 32px; transition: all 0.3s; }
  .tp-inc-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.08); transform: translateY(-3px); border-color: #d1fae5; }
  .tp-inc-icon { width: 52px; height: 52px; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 24px; margin-bottom: 20px; }
  .tp-inc-card h3 { font-size: 1.05rem; font-weight: 700; color: #1e293b; margin-bottom: 10px; }
  .tp-inc-card p { font-size: 0.9rem; color: #64748b; line-height: 1.7; }

  /* ─── Process ───────────────────────────────────────────────── */
  .tp-process { background: #fff; }
  .tp-process-inner { background: #0f172a; border-radius: 32px; padding: 80px 64px; position: relative; overflow: hidden; }
  @media (max-width: 900px) { .tp-process-inner { padding: 48px 32px; } }
  .tp-proc-glow1 { position: absolute; top: 0; right: 0; width: 400px; height: 400px; background: radial-gradient(circle, rgba(16,185,129,0.2), transparent 70%); pointer-events: none; }
  .tp-proc-glow2 { position: absolute; bottom: 0; left: 0; width: 350px; height: 350px; background: radial-gradient(circle, rgba(14,165,233,0.12), transparent 70%); pointer-events: none; }
  .tp-proc-header { text-align: center; margin-bottom: 64px; position: relative; z-index: 1; }
  .tp-proc-header .tp-label { color: #6ee7b7; }
  .tp-proc-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #fff; letter-spacing: -0.02em; }
  .tp-proc-header p { font-size: 1.05rem; color: #94a3b8; margin-top: 16px; line-height: 1.7; }
  .tp-steps { display: grid; grid-template-columns: repeat(4,1fr); gap: 28px; position: relative; z-index: 1; }
  @media (max-width: 900px) { .tp-steps { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 600px) { .tp-steps { grid-template-columns: 1fr; } }
  .tp-step { position: relative; }
  .tp-step-num { width: 44px; height: 44px; border-radius: 12px; background: rgba(16,185,129,0.15); border: 1px solid rgba(16,185,129,0.3); display: flex; align-items: center; justify-content: center; font-size: 16px; font-weight: 800; color: #34d399; margin-bottom: 20px; }
  .tp-step h3 { font-size: 1.05rem; font-weight: 700; color: #f1f5f9; margin-bottom: 10px; }
  .tp-step p { font-size: 0.88rem; color: #94a3b8; line-height: 1.7; }

  /* ─── Return Types ───────────────────────────────────────────── */
  .tp-types { background: #f8fafc; }
  .tp-types-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 20px; }
  @media (max-width: 768px) { .tp-types-grid { grid-template-columns: 1fr; } }
  .tp-type-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 20px; padding: 28px 32px; display: flex; gap: 20px; align-items: flex-start; transition: all 0.3s; }
  .tp-type-card:hover { border-color: #6ee7b7; box-shadow: 0 12px 40px rgba(0,0,0,0.07); transform: translateY(-2px); }
  .tp-type-emoji { font-size: 28px; flex-shrink: 0; margin-top: 2px; }
  .tp-type-card h3 { font-size: 1.05rem; font-weight: 700; color: #1e293b; margin-bottom: 8px; }
  .tp-type-card p { font-size: 0.9rem; color: #64748b; line-height: 1.65; margin-bottom: 14px; }
  .tp-type-tags { display: flex; flex-wrap: wrap; gap: 6px; }
  .tp-type-tag { padding: 3px 10px; border-radius: 999px; font-size: 11px; font-weight: 600; background: #f1f5f9; color: #475569; }
  .tp-type-card:hover .tp-type-tag { background: #d1fae5; color: #065f46; }

  /* ─── Deductions ─────────────────────────────────────────────── */
  .tp-deductions { background: #fff; }
  .tp-ded-inner { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  @media (max-width: 900px) { .tp-ded-inner { grid-template-columns: 1fr; gap: 48px; } }
  .tp-ded-left h2 { font-size: clamp(1.8rem, 3.5vw, 2.6rem); font-weight: 800; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .tp-ded-left > p { font-size: 1.05rem; color: #64748b; line-height: 1.75; margin-bottom: 36px; }
  .tp-ded-list { display: flex; flex-direction: column; gap: 14px; }
  .tp-ded-item { display: flex; align-items: center; gap: 14px; padding: 14px 18px; background: #f8fafc; border: 1px solid #f1f5f9; border-radius: 12px; transition: all 0.2s; }
  .tp-ded-item:hover { background: #f0fdf4; border-color: #d1fae5; }
  .tp-ded-icon { font-size: 20px; flex-shrink: 0; }
  .tp-ded-text { font-size: 14px; font-weight: 600; color: #374151; flex: 1; }
  .tp-ded-amount { font-size: 13px; font-weight: 700; color: #059669; }
  .tp-ded-visual { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 24px; padding: 36px; }
  .tp-ded-vis-header { font-size: 15px; font-weight: 800; color: #0f172a; margin-bottom: 24px; }
  .tp-ded-checklist { display: flex; flex-direction: column; gap: 12px; margin-bottom: 28px; }
  .tp-ded-check { display: flex; align-items: center; gap: 12px; font-size: 14px; color: #374151; font-weight: 500; }
  .tp-ded-check-mark { width: 20px; height: 20px; border-radius: 50%; background: #d1fae5; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; color: #059669; flex-shrink: 0; }
  .tp-ded-total { padding: 18px; background: linear-gradient(135deg, #0f172a, #1e293b); border-radius: 14px; display: flex; justify-content: space-between; align-items: center; }
  .tp-ded-total span:first-child { font-size: 14px; color: #94a3b8; font-weight: 500; }
  .tp-ded-total span:last-child { font-size: 22px; font-weight: 900; color: #34d399; }

  /* ─── FAQ ───────────────────────────────────────────────────── */
  .tp-faq { background: #f8fafc; }
  .tp-faq-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 18px; }
  @media (max-width: 768px) { .tp-faq-grid { grid-template-columns: 1fr; } }
  .tp-faq-item { background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; padding: 26px; transition: all 0.2s; }
  .tp-faq-item:hover { border-color: #d1fae5; box-shadow: 0 4px 16px rgba(0,0,0,0.05); }
  .tp-faq-q { font-size: 0.98rem; font-weight: 700; color: #0f172a; margin-bottom: 10px; display: flex; gap: 10px; align-items: flex-start; }
  .tp-faq-q-icon { width: 22px; height: 22px; border-radius: 6px; background: #d1fae5; display: flex; align-items: center; justify-content: center; font-size: 12px; color: #059669; flex-shrink: 0; margin-top: 1px; }
  .tp-faq-a { font-size: 0.9rem; color: #64748b; line-height: 1.7; }

  /* ─── CTA ────────────────────────────────────────────────────── */
  .tp-cta { background: #fff; border-top: 1px solid #f1f5f9; padding: 96px 24px; }
  .tp-cta-inner { background: #0f172a; border-radius: 32px; padding: 80px 48px; text-align: center; position: relative; overflow: hidden; max-width: 1000px; margin: 0 auto; }
  @media (max-width: 600px) { .tp-cta-inner { padding: 48px 24px; } }
  .tp-cta-glow1 { position: absolute; top: 0; right: 0; width: 360px; height: 360px; background: radial-gradient(circle, rgba(16,185,129,0.22), transparent 70%); pointer-events: none; }
  .tp-cta-glow2 { position: absolute; bottom: 0; left: 0; width: 300px; height: 300px; background: radial-gradient(circle, rgba(14,165,233,0.15), transparent 70%); pointer-events: none; }
  .tp-cta-inner h2 { font-size: clamp(2rem,4vw,3rem); font-weight: 900; color: #fff; letter-spacing: -0.03em; line-height: 1.15; margin-bottom: 20px; position: relative; z-index: 1; }
  .tp-cta-inner p { font-size: 1.1rem; color: #94a3b8; font-weight: 300; max-width: 540px; margin: 0 auto 40px; line-height: 1.75; position: relative; z-index: 1; }
  .tp-cta-btns { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; margin-bottom: 36px; }
  .tp-cta-primary { padding: 16px 32px; background: linear-gradient(135deg, #059669, #10b981); color: #fff; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; box-shadow: 0 4px 20px rgba(5,150,105,0.4); }
  .tp-cta-primary:hover { transform: translateY(-1px); box-shadow: 0 8px 28px rgba(5,150,105,0.5); }
  .tp-cta-secondary { padding: 16px 32px; background: rgba(255,255,255,0.06); color: #fff; border: 1px solid rgba(255,255,255,0.15); border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .tp-cta-secondary:hover { background: rgba(255,255,255,0.1); }
  .tp-cta-badges { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; }
  .tp-cta-badge { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #94a3b8; }
  .tp-cta-badge-check { color: #34d399; }
`;

const fadeIn = { initial:{opacity:0,y:28}, whileInView:{opacity:1,y:0}, viewport:{once:true,margin:'-50px'}, transition:{duration:0.55} };
const stagger = (i:number) => ({ initial:{opacity:0,y:24}, whileInView:{opacity:1,y:0}, viewport:{once:true,margin:'-40px'}, transition:{duration:0.5,delay:i*0.1} });

const included = [
  { icon:'📋', bg:'#f0fdf4', title:'Federal & State Returns', desc:'Complete preparation and filing of all required federal and state income tax returns for your specific entity type.' },
  { icon:'🔍', bg:'#f0f9ff', title:'Deduction Review', desc:'Thorough line-by-line review of every potential deduction and credit — we leave nothing on the table.' },
  { icon:'📊', bg:'#fefce8', title:'Prior Year Comparison', desc:'Side-by-side analysis with your prior return to flag changes, catch missed items, and identify trends.' },
  { icon:'🛡️', bg:'#fdf4ff', title:'Audit-Ready Filing', desc:'Every return is prepared to withstand IRS scrutiny, with organized documentation and proper substantiation.' },
  { icon:'💬', bg:'#fff7ed', title:'CPA Review & Sign-Off', desc:'A licensed CPA reviews and signs every return — not a software algorithm. Real expertise, real accountability.' },
  { icon:'📁', bg:'#f0fdfa', title:'Secure Document Portal', desc:'Upload documents and access your return history anytime through our encrypted, bank-grade secure client portal.' },
];

const steps = [
  { num:'01', title:'Upload Documents', desc:'Use our secure portal checklist to upload your documents. We guide you on exactly what\'s needed — no guesswork.' },
  { num:'02', title:'CPA Review', desc:'A dedicated CPA reviews your situation, researches entity-specific deductions, and identifies every savings opportunity.' },
  { num:'03', title:'Draft & Approval', desc:'We send you a complete draft return with a plain-English summary of findings. You review, ask questions, and approve.' },
  { num:'04', title:'File & Confirm', desc:'We e-file your return and send confirmation with tracking. You receive a copy and all supporting workpapers.' },
];

const returnTypes = [
  { emoji:'👤', title:'Individual & Sole Proprietor (1040)', desc:'Full Schedule C preparation with all business deductions, home office, vehicle, and self-employment tax optimization.', tags:['Form 1040','Schedule C','SE Tax'] },
  { emoji:'🤝', title:'Partnership & Multi-Member LLC (1065)', desc:'Complete partnership return with K-1s for all partners, allocation review, and self-employment tax planning.', tags:['Form 1065','Schedule K-1','Partner Allocations'] },
  { emoji:'🏢', title:'S-Corporation (1120-S)', desc:'Corporate return with officer compensation analysis, K-1 preparation, and built-in gains tax review.', tags:['Form 1120-S','Officer W-2','Distributions'] },
  { emoji:'🏛️', title:'C-Corporation (1120)', desc:'Corporate tax return with accumulated earnings analysis, dividend planning, and alternative minimum tax review.', tags:['Form 1120','AMT Review','Dividend Strategy'] },
];

const deductions = [
  { icon:'🏠', label:'Home Office Deduction', amount:'Up to $1,500+' },
  { icon:'🚗', label:'Vehicle & Mileage', amount:'67¢ per mile' },
  { icon:'💻', label:'Equipment & Technology', desc:'Section 179', amount:'100% deductible' },
  { icon:'🏥', label:'Health Insurance Premiums', amount:'100% deductible' },
  { icon:'📚', label:'Education & Training', amount:'Fully deductible' },
  { icon:'✈️', label:'Business Travel & Meals', amount:'50–100%' },
];

const faqs = [
  { q:'How long does the process take?', a:'Most individual returns are completed within 5 business days of receiving your complete documents. Business returns take 7–10 business days. Rush processing is available.' },
  { q:'What documents do I need to provide?', a:'We send you a customized checklist based on your situation. Common items include prior year returns, W-2s, 1099s, and expense records. Our portal makes uploading simple.' },
  { q:'Can you fix errors on a previously filed return?', a:'Yes. We regularly prepare amended returns (Form 1040-X) to correct errors or claim missed deductions. There is typically a 3-year window to amend and claim a refund.' },
  { q:'Do you guarantee accuracy?', a:'Absolutely. If an error on our part results in a penalty or interest, we cover it entirely. We also stand behind all positions taken on your return in the event of an audit.' },
  { q:'What if I have multiple states?', a:'We handle multi-state returns routinely. We\'ll identify your filing obligations in each state and prepare all required returns, including non-resident and part-year returns.' },
  { q:'Is my data secure?', a:'Yes. All documents are handled through our AES-256 encrypted portal. We never email sensitive documents and follow strict data security and confidentiality protocols.' },
];

const TaxPreparation: React.FC<{ onBack?: () => void }> = ({ onBack }) => (
  <div className="tp-page">
    <style>{styles}</style>

    {/* Hero */}
    <section className="tp-hero">
      <div className="tp-hero-blob1" />
      <div className="tp-hero-blob2" />
      <div className="tp-hero-inner">
        <div>
          {onBack && (
            <button type="button" className="tp-back-btn" onClick={onBack}>
              <span aria-hidden="true">←</span> Back to Tax Services
            </button>
          )}
          <motion.div initial={{opacity:0,scale:0.9}} animate={{opacity:1,scale:1}} transition={{duration:0.5}}>
            <div className="tp-hero-badge"><span className="tp-badge-dot" />Trusted by 2,800+ business owners</div>
          </motion.div>
          <motion.h1 initial={{opacity:0,y:30}} animate={{opacity:1,y:0}} transition={{duration:0.6,delay:0.1}}>
            Accurate Returns.<br /><span className="tp-gradient-text">Maximum Refund.</span><br />Zero Stress.
          </motion.h1>
          <motion.p initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.6,delay:0.2}}>
            Stop filing blind. Our CPAs prepare every return with a forensic eye for deductions — leaving nothing on the table and giving you peace of mind that everything is done right.
          </motion.p>
          <motion.div className="tp-btn-group" initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.5,delay:0.3}}>
            <button type="button" className="tp-btn-primary">Start My Return →</button>
            <button type="button" className="tp-btn-secondary">See What's Included</button>
          </motion.div>
        </div>
        <motion.div className="tp-hero-visual" initial={{opacity:0,x:40}} animate={{opacity:1,x:0}} transition={{duration:0.7,delay:0.2}}>
          <div className="tp-vis-header">
            <div className="tp-vis-title"><p>Document Checklist</p><p>2024 Business Return</p></div>
            <div className="tp-vis-icon">📋</div>
          </div>
          {[
            {label:'Prior Year Return (2023)', done:true},
            {label:'Bank Statements (All Accounts)', done:true},
            {label:'1099-NEC / 1099-K Forms', done:true},
            {label:'Expense Receipts & Records', done:true},
            {label:'Vehicle Mileage Log', done:false},
            {label:'Asset Purchase Receipts', done:false},
          ].map((doc,i) => (
            <div className={`tp-doc-item ${doc.done?'done':''}`} key={i}>
              <div className={`tp-doc-check ${doc.done?'done':'pending'}`}>{doc.done?'✓':'○'}</div>
              <span className={`tp-doc-label ${doc.done?'done':''}`}>{doc.label}</span>
              <span className={`tp-doc-status ${doc.done?'done':'pending'}`}>{doc.done?'Received':'Pending'}</span>
            </div>
          ))}
          <div className="tp-vis-progress">
            <div className="tp-vis-progress-top"><span>Return Readiness</span><span>4 of 6 items received</span></div>
            <div className="tp-progress-bar"><div className="tp-progress-fill" /></div>
          </div>
        </motion.div>
      </div>
    </section>

    {/* Stats */}
    <div className="tp-stats">
      <div className="tp-stats-grid">
        {[
          {num:'2,800+',label:'Returns Filed This Year',dark:false},
          {num:'$1.2M+',label:'Tax Savings Uncovered',dark:false},
          {num:'100%',label:'Accuracy Guarantee',dark:true},
          {num:'5 Days',label:'Average Turnaround Time',dark:true},
        ].map((s,i) => (
          <motion.div className="tp-stat" key={i} {...stagger(i)}>
            <div className={`tp-stat-num${s.dark?' dark':''}`}>{s.num}</div>
            <div className="tp-stat-label">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </div>

    {/* What's Included */}
    <section className="tp-section tp-included">
      <div className="tp-container">
        <motion.div className="tp-section-header" {...fadeIn}>
          <span className="tp-label">Everything Included</span>
          <h2>No Add-Ons. No Surprises. Everything You Need.</h2>
          <p>Every tax preparation engagement includes the full suite of services below — all for one transparent, flat fee.</p>
        </motion.div>
        <div className="tp-included-grid">
          {included.map((item,i) => (
            <motion.div className="tp-inc-card" key={i} {...stagger(i)}>
              <div className="tp-inc-icon" style={{background:item.bg}}>{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* Process */}
    <section className="tp-section tp-process">
      <div className="tp-container">
        <div className="tp-process-inner">
          <div className="tp-proc-glow1" /><div className="tp-proc-glow2" />
          <motion.div className="tp-proc-header" {...fadeIn}>
            <span className="tp-label">How It Works</span>
            <h2>From Documents to Filed Return in 4 Simple Steps</h2>
            <p>We handle the heavy lifting. You stay informed at every stage with clear communication and no jargon.</p>
          </motion.div>
          <div className="tp-steps">
            {steps.map((s,i) => (
              <motion.div className="tp-step" key={i} {...stagger(i)}>
                <div className="tp-step-num">{s.num}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* Return Types */}
    <section className="tp-section tp-types">
      <div className="tp-container">
        <motion.div className="tp-section-header" {...fadeIn}>
          <span className="tp-label">Return Types</span>
          <h2>We Prepare Every Type of Business Return</h2>
          <p>From solo freelancers to multi-entity corporations — our CPAs are experienced with every business structure.</p>
        </motion.div>
        <div className="tp-types-grid">
          {returnTypes.map((t,i) => (
            <motion.div className="tp-type-card" key={i} {...stagger(i)}>
              <span className="tp-type-emoji">{t.emoji}</span>
              <div>
                <h3>{t.title}</h3>
                <p>{t.desc}</p>
                <div className="tp-type-tags">{t.tags.map((tag,j) => <span className="tp-type-tag" key={j}>{tag}</span>)}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* Deductions */}
    <section className="tp-section tp-deductions">
      <div className="tp-container">
        <div className="tp-ded-inner">
          <motion.div className="tp-ded-left" {...fadeIn}>
            <span className="tp-label">What We Find</span>
            <h2>The Deductions Most Business Owners Miss</h2>
            <p>The average small business owner misses thousands in legitimate deductions every year. Our CPAs know exactly where to look.</p>
            <div className="tp-ded-list">
              {deductions.map((d,i) => (
                <div className="tp-ded-item" key={i}>
                  <span className="tp-ded-icon">{d.icon}</span>
                  <span className="tp-ded-text">{d.label}</span>
                  <span className="tp-ded-amount">{d.amount}</span>
                </div>
              ))}
            </div>
          </motion.div>
          <motion.div className="tp-ded-visual" initial={{opacity:0,x:30}} whileInView={{opacity:1,x:0}} viewport={{once:true}} transition={{duration:0.6,delay:0.2}}>
            <div className="tp-ded-vis-header">✅ Your Complete Return Includes</div>
            <div className="tp-ded-checklist">
              {['All income sources reconciled','Every deduction documented & substantiated','Retirement contribution optimization','Health insurance deduction applied','Home office calculated & verified','Vehicle deduction method selected (actual vs. mileage)','QBI deduction applied where eligible','Prior year carryforwards reviewed','State & local deductions maximized','E-filed with IRS and state confirmation'].map((item,i) => (
                <div className="tp-ded-check" key={i}><div className="tp-ded-check-mark">✓</div>{item}</div>
              ))}
            </div>
            <div className="tp-ded-total">
              <span>Average Additional Savings Found</span>
              <span>$4,200+</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>

    {/* FAQ */}
    <section className="tp-section tp-faq">
      <div className="tp-container">
        <motion.div className="tp-section-header" {...fadeIn}>
          <span className="tp-label">Common Questions</span>
          <h2>Everything You Need to Know Before Getting Started</h2>
          <p>Have a question not covered here? We respond to all inquiries within one business day.</p>
        </motion.div>
        <div className="tp-faq-grid">
          {faqs.map((f,i) => (
            <motion.div className="tp-faq-item" key={i} {...stagger(i)}>
              <div className="tp-faq-q"><div className="tp-faq-q-icon">?</div>{f.q}</div>
              <div className="tp-faq-a">{f.a}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="tp-cta">
      <div className="tp-cta-inner">
        <div className="tp-cta-glow1" /><div className="tp-cta-glow2" />
        <motion.h2 {...fadeIn}>Ready to File With Confidence?</motion.h2>
        <motion.p {...{...fadeIn,transition:{duration:0.55,delay:0.1}}}>
          Get your return done right — by a real CPA who knows your business. Start today and join thousands of owners who no longer dread tax season.
        </motion.p>
        <motion.div className="tp-cta-btns" {...{...fadeIn,transition:{duration:0.5,delay:0.2}}}>
          <button type="button" className="tp-cta-primary">Start My Return →</button>
          <button type="button" className="tp-cta-secondary">Get a Free Quote</button>
        </motion.div>
        <motion.div className="tp-cta-badges" {...{...fadeIn,transition:{duration:0.5,delay:0.3}}}>
          {['Flat-fee pricing','100% accuracy guarantee','Licensed CPAs only','Secure document portal'].map((b,i) => (
            <div className="tp-cta-badge" key={i}><span className="tp-cta-badge-check">✓</span>{b}</div>
          ))}
        </motion.div>
      </div>
    </section>
  </div>
);

export default TaxPreparation;
